import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { oneOf } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import '../../tooltip.scss';
import { buildImageURL } from '../../../utils/product-add-on-utils';

import { ICONS, DETAILS_URL } from '../../../utils/product-add-on-constants';

export const ProtectionPlanTooltip = forwardRef(({ channel }, buttonRef) => {

  const toolTipLabelClasses = classNames({
    'u__default-link': true,
    'product-add-on-tooltip-content__label': true,
    scrollTouch: channel === 'mobile',
  });

  const tooltip = (
    <div className="product-add-on-tooltip-content" data-channel={`${channel}`}>
      <div className="product-add-on-tooltip-content__header">The Home Depot Protection Plan by Allstate</div>
      <div className="product-add-on-tooltip-content__body">

        <p>
          Protection plans that get it done.
        </p>

        <ul className="product-add-on-tooltip-content__list">
          <li>Covers 100% parts and labor for product breakdowns & defects</li>
          <li>No deductibles or hidden fees</li>
          <li>Premium tech support for smart devices</li>
          <li>Fast repairs or replacements</li>
          <li> 24/7 customer support & easy online claims.</li>

        </ul>
        <div className="product-add-on-tooltip-content__hdpp-section">
          <p>
            Covers your purchase for 3 or 2 years after the manufacturer’s labor warranty ends.
          </p>
          <p>
            Your protection plan details will be emailed to you after purchase.
            <br />
            <a
              href={DETAILS_URL}
              target="_blank"
              className="u__default-link"
              rel="noopener noreferrer"
            >
              Plan Details
            </a>
          </p>
        </div>

        <p className="product-add-on-tooltip-content__all-state-content">
          <img
            className="product-add-on-tooltip-content__logo__all-state-img-styling"
            src={buildImageURL(ICONS.hdpp)}
            alt=""
            aria-hidden="true"
          />
        </p>
      </div>
    </div>
  );

  return (
    <Tooltip channel={channel} placement="bottom" content={tooltip} closeButton>
      <button ref={buttonRef} type="button" className={toolTipLabelClasses}>
        Learn more
        <img
          src={buildImageURL(ICONS.info)}
          alt="information tooltip"
          className="product-add-on-tooltip-content__label__suffix"
        />
      </button>
    </Tooltip>
  );
});

ProtectionPlanTooltip.displayName = 'ProductAddOns-HdppTooltip';

ProtectionPlanTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
};

ProtectionPlanTooltip.defaultProps = {
  channel: oneOf(['desktop', 'mobile']),
};
